import API from '@MAIN/app/api'
import Modal from '@MAIN/app/modules/Modal'
import Analytics from '../modules/Analytics'

$('.js-lead-form').submit(e => {
  e.preventDefault()

  const $form = $(e.target)

  $form.find('button[type=submit]').attr('disabled', 'disabled')

  if ($form.data('goal')) {
    Analytics.createLead( $form.data('goal') )
  }

  API.form.send($form.attr('action'), $form.serialize() )
    .then(() => {
      Modal.setType('result').then(() => {
        Modal.getComponent().setContent(
          $form.data('result-title'),
          $form.data('result-text')
        )
      })

      e.target.reset()
      $form.find('button[type=submit]').removeAttr('disabled')
    })
})

$('.js-goal-after-submit').submit(e => {
  const $form = $(e.target)

  if ($form.data('goal')) {
    Analytics.createLead( $form.data('goal') )
  }
})
